import { useEffect, useState } from "react";
import { loadRemote } from '@module-federation/runtime';
import { mfe as i18nNamespace } from "../../i18n/namespace";
import { useTranslation } from "react-i18next";

function useDynamicImport({ module, scope }) {
    const [component, setComponent] = useState();
    const [notification, setNotification] = useState();
    const { t } = useTranslation(i18nNamespace);

    useEffect(() => {
      if (!module || !scope) return;
  
      const loadComponent = async () => {
        try {
          const Component = await loadRemote(`${scope}/${module}`);
          setComponent(() => Component.ModuleFederatedRemoteComponent);
        } catch (error) {
          console.error(error);
          setNotification(t('failed_to_load_mfe', { module, scope }));
        }
      };
  
      loadComponent();
    }, [module, scope]);
  
    return [component, notification];
}

export default useDynamicImport;